export default "__VITE_ASSET__CxK$j4z$__"